import api from "./core";

const basePath = "api/core/VitalRecords";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(isClientId, id, DateTimeFrom = null, DateTimeTo = null) {
    return api.post(
      `${basePath}`,
      isClientId
        ? {
            patientId: id,
            DateTimeFrom,
            DateTimeTo
          }
        : {
            episodeOfCareId: id,
            DateTimeFrom,
            DateTimeTo
          },
    );
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
